export function adminTicketTabularColumn() {
  return [
    {
      name: 'id',
      title: 'شماره تیکت'
    },
    {
      name: 'status',
      title: 'وضعیت'
    },
    {
      name: 'department',
      title: 'دپارتمان'
    },
    {
      name: 'last_answer_date',
      title: 'تاریخ آخرین پاسخ'
    },
    {
      name: 'ticketable',
      title: 'آیتم مرتبط'
    },
    {
      name: 'user',
      title: `کاربر`
    },
    //TODO person
    // {
    //   name: 'person',
    //   title: `ثبت در`
    // },
    {
      name: 'created_at',
      title: 'تاریخ ایجاد'
    }
  ]
}

const bannedColumns = ['user']

export const ticketTabularColumn = () => adminTicketTabularColumn()
  .filter(column => !bannedColumns.includes(column.name))
